// Cuántas imágenes va a entregar la corrida que se acaba de disparar —
// ADR-2026-09-06-la-tanda-de-fotos-de-producto-cuenta-producto-por-vista.
//
// Es el número de recuadros que abre la tanda en la columna de resultados (uno por
// imagen) y el tope del poll. Cada modo lo calcula distinto, y ahí estaba el bug que
// esto viene a cerrar: la cuenta vivía suelta en `handleGenerate` con una sola rama
// (`design-auto`) y TODO lo demás caía en la de Modelo. Fotos de producto, cuya tanda
// es producto × vista, terminaba con `1 × 1 × contador` = 1 y dibujaba una sola card
// de "generando" con seis imágenes corriendo.
//
// Vive afuera del componente y en un módulo propio —y no en `designModeloCount.ts`,
// que es específicamente sobre el contador de Modelo— porque es la cuenta de TODOS los
// modos y porque así se puede testear sin navegador, que es lo único que hace que un
// modo nuevo no vuelva a caer en la rama equivocada sin que nadie se entere.

import {
  resolveDesignModeloCount,
  totalTandaDesignModelo,
} from './designModeloCount';

export interface TotalTandaInput {
  /** `preset.kind` de la corrida. */
  kind: string | undefined;
  /** El contador +/- crudo. Es un estado COMPARTIDO por todos los modos. */
  autoImageCount: number;
  /** Tope del contador (`AUTO_IMAGE_COUNT_MAX`). */
  max: number;
  /** Modelos de la serie: 1 con selección única. */
  modelCount: number;
  /** Poses elegidas. 0 = pose Automática, cuenta como 1. */
  poseCount: number;
  multiModelEnabled: boolean;
  /** Producto × vista, para Fotos de producto (`fotosProductoTotalImagenes`). */
  fotosProductoTotal: number;
}

export function totalTandaDeLaCorrida({
  kind,
  autoImageCount,
  max,
  modelCount,
  poseCount,
  multiModelEnabled,
  fotosProductoTotal,
}: TotalTandaInput): number {
  // Automático no combina nada: son las N del contador.
  if (kind === 'design-auto') {
    return Math.max(1, Math.min(max, Math.trunc(autoImageCount) || 1));
  }
  // Fotos de producto es una CUENTA (una imagen por par producto-vista), no una
  // elección: el contador no se muestra en ese modo y los modelos y poses que hayan
  // quedado elegidos en otro no tienen nada que ver con esta tanda. El piso de 1 es
  // defensivo —sin vistas el Generar está bloqueado—: una tanda de cero recuadros
  // nacería terminada sin haber mostrado nada.
  if (kind === 'fotos-producto') {
    return Math.max(1, fotosProductoTotal);
  }
  // El resto —Modelo y las plantillas que pasan por el mismo `handleGenerate`—
  // multiplica modelos × poses × contador, con el contador ya resuelto a 1 cuando no
  // aplica.
  return totalTandaDesignModelo({
    modelCount,
    poseCount,
    count: resolveDesignModeloCount({
      rawCount: autoImageCount,
      poseCount,
      multiModelEnabled,
      modelCount,
      max,
    }).count,
  });
}

export default totalTandaDeLaCorrida;
